import type { ContactChatRoomQuery } from "@/lib/gql/__generated__/graphql";

import {
	FeatureIslandContainer,
	FeatureIslandHeader,
	FeatureIslandMainWithBackGround,
} from "@/components/features/_layouts";

import { useContactForm } from "../../hooks";
import { HeaderRightButton } from "../header-right-button";
import { Chat } from "./chat";
import { Form } from "./form";
import { HeaderInner } from "./header-innner";

type Props = {
	hotelID: string;
	contactID: string;

	data: ContactChatRoomQuery;
};

export const ChatRoom = ({ data, hotelID, contactID }: Props) => {
	const { form } = useContactForm({ hotelID, contactID });

	return (
		<FeatureIslandContainer>
			<FeatureIslandHeader title="チャットルーム" rightChildren={<HeaderRightButton form={form} />} />

			<FeatureIslandMainWithBackGround>
				<HeaderInner contact={data.contact} />
				<Chat contact={data.contact} />
				<Form form={form} />
			</FeatureIslandMainWithBackGround>
		</FeatureIslandContainer>
	);
};

ChatRoom.displayName = "ChatRoom";
